import React from 'react';
import { Box, Typography, Grid, Card, CardContent } from '@mui/material';
import { useAuth } from '../../context/AuthContext';

const Dashboard = () => {
  const { user, selectedOrganisation, organisations } = useAuth();

  return (
    <Box>
      <Typography variant="h4" gutterBottom fontWeight={600}>
        Dashboard
      </Typography>
      
      <Grid container spacing={3}>
        <Grid item xs={12} md={6}>
          <Card>
            <CardContent>
              <Typography variant="h6" gutterBottom>
                Welcome back!
              </Typography>
              <Typography variant="body2" color="text.secondary">
                You are logged in as: <strong>{user?.email}</strong>
              </Typography>
              {selectedOrganisation && (
                <Typography variant="body2" color="text.secondary">
                  Current Organisation: <strong>{selectedOrganisation.name}</strong>
                </Typography>
              )}
              {organisations && organisations.length > 1 && (
                <Typography variant="body2" color="text.secondary">
                  You have access to {organisations.length} organisations
                </Typography>
              )}
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </Box>
  );
};

export default Dashboard;